import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    examCenterListLoading: false,
    examCenterListSuccess: null,
    examCenterListError: '',

    getExamCenterLoading: false,
    getExamCenterSuccess: null,
    getExamCenterError: '',

    createExamCenterLoading: false,
    createExamCenterSuccess: {},
    createExamCenterError: '',
}

export const examCenterSlice = createSlice({
    name: 'examCenter',
    initialState, 
    reducers: {
        setExamCenterListLoading: (state) => {
            state.examCenterListLoading = true;
            state.examCenterListSuccess = null;
            state.examCenterListError = '';
        },
        setExamCenterListSuccess: (state, action) => {
            state.examCenterListLoading = false;
            state.examCenterListSuccess = action.payload;
            state.examCenterListError = '';
        },
        setExamCenterListError: (state, action) => {
            state.examCenterListLoading = false;
            state.examCenterListSuccess = null;
            state.examCenterListError = action.payload;
        },
        setGetExamCenterLoading: (state) => {
            state.getExamCenterLoading = true;
            state.getExamCenterSuccess = {};
            state.getExamCenterError = '';
        },
        setGetExamCenterSuccess: (state, action) => {
            state.getExamCenterLoading = false;
            state.getExamCenterSuccess = action.payload;
            state.getExamCenterError = '';
        },
        setGetExamCenterError: (state, action) => {
            state.getExamCenterLoading = false;
            state.getExamCenterSuccess = {};
            state.getExamCenterError = action.payload;
        },
        setCreateExamCenterLoading: (state) => {
            state.createExamCenterLoading = true;
            state.createExamCenterSuccess = {};
            state.createExamCenterError = '';
        },
        setCreateExamCenterSuccess: (state, action) => {
            state.createExamCenterLoading = false;
            state.createExamCenterSuccess = action.payload;
            state.createExamCenterError = '';
        },
        setCreateExamCenterError: (state, action) => {
            state.createExamCenterLoading = false;
            state.createExamCenterSuccess = {};
            state.createExamCenterError = action.payload;
        },
        resetDetails: (state) => {
            state.getExamCenterSuccess = {};
            state.createExamCenterSuccess = {};
        },
    }
})

export const { setExamCenterListLoading, setExamCenterListSuccess, setExamCenterListError,
    setGetExamCenterLoading, setGetExamCenterSuccess, setGetExamCenterError, 
    setCreateExamCenterLoading, setCreateExamCenterSuccess, setCreateExamCenterError,
    resetDetails
} = examCenterSlice.actions;


export default examCenterSlice.reducer;